import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        <div className="copyright">
          <a>&copy; CiberMed Inc. {new Date().getFullYear()}</a>
        </div>
        <div className="footer-routes">
          <Link to="/faq">FAQ</Link>
          <Link to="/privacypolicy">Privacy Statement</Link>
          <Link to="/termsofuse">Terms of Use</Link>
        </div>
      </div>
      <Link
        to="https://www.cibermed.com"
        target="_blank"
        className="footer-right footer-cibermed"
      >VISIT CIBERMED.COM
      </Link>
    </footer>
  );
}
